import React, { Component } from 'react';
import Layout from '~/src/layout/_layout';
import MeetingPage from '~/src/components/Meeting';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import * as base from '~/src/helpers/basePageFunc';

class DomofonMeetingPage extends Component {

  static async getInitialProps(options) {
    const { req, store } = options;
    const relCanonical = get(req, 'headers.host', '');
    const { hostname } = await base.initialProps(options);
    const state = store.getState();
    const phone = state.city.currentCity.phone;
    const currentCity = state.city.currentCity;
    return ({
      relCanonical,
      hostname,
      phone,
      currentCity,
    });
  }

  render() {
    const { relCanonical, hostname, phone, currentCity } = this.props;
    return (
      <Layout
        title={`Установка домофона от Дом.ру в ${currentCity.cityIn}, инструкция`}
        description={`Пошаговая инструкция по подключению домофона от Дом.ру в подъезде дома. Мы подготовили для Вас бланки документов, рекомендованные для проведения собрания по установке домофона. Остались вопросы? Позвоните ☎ ${phone}.`}
        withMenu={true}
        withFooter={true}
        withChat={true}
        relCanonical={`https://${relCanonical}/domofon/meeting`}
        hostname={hostname}>
        <MeetingPage phone={phone}/>
      </Layout>
    );
  }
}

DomofonMeetingPage.propTypes = {
  phone: PropTypes.string,
  hostname: PropTypes.string,
  relCanonical: PropTypes.string,
};

DomofonMeetingPage.defaultProps = {
  hostname: '',
  relCanonical: '',
  phone: ''
};

export default DomofonMeetingPage;
